import React, { useState,useRef } from "react";
import { Empty, Input, Button } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import editIcon from "../../assets/edit.svg";
import PieChart from "../PieChart";
import StackChart from "../StackChart";

import "./rtable.scss";


export default function RTable({
    isClickable = false,
    titleList,
    data,
    isResumePage = false,
    isEditField = false,
    editFieldHandler,
    setCurrentView,
    resumeProfileHandler,
    jdID, 
    emptyString
}) {
    const navigate = useNavigate();
    const inputRef = useRef(null);

    if (!data) {
        return <Empty style={{ margin: "60px" }}>
                 {emptyString}
        </Empty> ;
    }

    const focusInputField = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    const handleResumeDetailClick = (id,qhID) => {
        resumeProfileHandler(jdID,id, qhID,)
        setCurrentView("profile")
        navigate(`candidateProfile/${id}/${qhID}`, { state: { jdID: jdID } });
        
    };
   const handleResumeStatsClick = (id)=>{
    navigate(id)
   }

    return (
        <div className="rtable-wrapper">
            <div
                className="rtable-title-wrapper"
                style={{
                    gridTemplateColumns: `50px 1fr 2fr repeat(${titleList.length-3}, 1fr)`
                }}
            >
                {titleList.map((title) => (
                    <div className="rtable-title">{title}
                    </div>
                ))}
            </div>
            {data?.map((table, rowIndex) => (
                <div
                    onClick={isResumePage ? () => handleResumeDetailClick(table.id, table.qhid) : () => handleResumeStatsClick(table.team_member_id ) }
                    key={table.id}
                    className="rtable-info-wrapper"
                    style={{
                        gridTemplateColumns: `50px 1fr 2fr repeat(${titleList.length-3}, 1fr)`,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="rtable-info">
                            {isEditField ? (
                               <></>
                            ) : (
                                table[tableInfo]==""?"--":table[tableInfo]
                            )}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
